import React, { useState } from 'react'
import { api_url } from '../../Constants/web_services';
import { useSelector } from 'react-redux';
import { selectUserData, selectSignedIn } from '../../Redux/UserSlice';
import { Slider } from 'antd';
import { useParams } from 'react-router-dom';


const RequestQuote = ({ company }) => {
    const isSignedIn = useSelector(selectSignedIn);
    const userData = useSelector(selectUserData);
    const [companyData] = useState(company);
    const [name, setName] = useState();
    const [email, setEmail] = useState();
    const [contact, setContact] = useState()
    const [message, setMessage] = useState();
    const [range, setRange] = useState([2000, 5000]);
    const [min] = useState(range[0]);
    const [max] = useState(range[1]);

    const { id } = useParams();

    const handleRangeChange = (value) => {
        setRange(value);

    };
    const handleForm = async (e) => {
        e.preventDefault();
        let infoData;

        if (isSignedIn) {
            infoData = {
                name: userData?.username,
                contact: userData?.contact,
                email: userData?.email,
                user_id: userData?.id,
                message,
                price_range_min: min,
                price_range_max: max,
                approval: 0,
                company_id: id,
            };
        } else {
            infoData = {
                name,
                contact,
                email,
                message,
                price_range_min: min,
                price_range_max: max,
                approval: 0,
                company_id: id,
            };
        }

        try {
            const response = await fetch(api_url + `/api/userquery`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Corrected header
                },
                body: JSON.stringify(infoData),
            });

            if (response.ok) {
                const responseData = await response.json();
                // Clear form fields
                setName('');
                setContact('');
                setEmail('');
                setMessage('');
                setRange([2000, 5000]); // Reset range or use appropriate values
            } else {
                const errorData = await response.json(); // Parse error response
                console.error('Send failed:', errorData.errors || 'Unknown error');
            }
        } catch (error) {
            console.error('Error during sendinfo', error);
        }
    };

    return (
        <>
            {/*Request a Quote*/}
            <div
                id="aon-provider-Req-quote"
                className="sf-provi-qoute-box cleafix m-b50 sf-provi-fullBox col-md-8 mb-0"
            >
                <h3 className="sf-provi-title fw-800 text-drk-primary s-22">Request a Quote</h3>
                <div className="sf-divider-line" />
                <div className="sf-provi-qform border-0 shadow rounded-3">
                    <form onSubmit={handleForm}>
                        <div className="row">
                            {isSignedIn ? (
                                <>

                                </>
                            )
                                :
                                (
                                    <>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className='fw-700 text-drk-primary'>Name</label>
                                                <input
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    name="name"
                                                    type="text"
                                                    required=""
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className='fw-700 text-drk-primary'>Email</label>
                                                <input
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    name="email"
                                                    type="email"
                                                    required=""
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className='fw-700 text-drk-primary'>Phone</label>
                                                <input
                                                    value={contact}
                                                    onChange={(e) => setContact(e.target.value)}
                                                    name="contact"
                                                    type="tel"
                                                    required=""
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                    </>
                                )
                            }
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className='fw-700 text-drk-primary'>Message</label>
                                    <textarea
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        name="message"
                                        rows={3}
                                        className="form-control"
                                        defaultValue={""}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className='fw-700 text-drk-primary'> Estimated Price Range</label>
                                    <Slider
                                        range
                                        min={10}      // Set the minimum value
                                        max={10000}  // Set the maximum value
                                        step={10}     // Set the step size
                                        defaultValue={[2000, 5000]}
                                        value={range}
                                        onChange={handleRangeChange}
                                    />
                                    <p>Selected Range: {range[0]}$ - {range[1]}$</p>
                                </div>


                            </div>
                            <div className="col-md-12">
                                <div className="form-group text-center qout-submit-btn">
                                    <input
                                        type="submit"
                                        defaultValue="Send information"
                                        className="site-button"
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default RequestQuote